export const DEFAULT_DATE_FORMAT = "DD/MM/YYYY";
export const DEFAULT_DATE_TIME_FORMAT = "DD/MM/YYYY - HH:mm:ss";
export const DATE_TIME_FORMAT_1 = "DD/MM/YYYY HH:mm";

export const ACCESS_TOKEN_KEY = "access_token";
export const REFRESH_TOKEN_KEY = "refresh_token";
export const USER_INFO_KEY = "user_info";
export const BUCKET_URL_KEY = "bucket_url";
export const READING_THEME_KEY = "reading_theme";
export const DEVICE_ID = "device_id";

export const DEBOUNCE_TIMER = 300;
export const MAX_SIZE_UPLOAD = 536870912; // bytes = 512 MB

export enum Role {
  ADMIN = "ROLE_ADMIN",
  USER = "ROLE_USER",
  AUTHOR = "ROLE_AUTHOR",
}

export enum OrderType {
  ASC = "ASC",
  DESC = "DESC",
}

export enum MenuLabel {
  USER_ACCOUNT = "Quản lý tài khoản",
  USER_LIBRARY = "Thư viện",
  USER_WALLET = "Ví của tôi",
  USER_AFFILIATE = "Affiliate",
  USER_TRANSACTION = "Lịch sử giao dịch",
  USER_RULES = "Điều khoản sử dụng",
  USER_POLICIES = "Chính sách bảo mật",
  USER_SUPPORT = "Trợ giúp & FAQs",
  REFERRER = "Người giới thiệu",
}

export enum RoutePath {
  SIGN_UP = "/register",
  SIGN_IN = "/login",
  RULE = "/rules",
  POLICY = "/policies",
  GOOGLE_CONSOLE = "/google-console",
  HOME = "/",
  SEARCH = "/search",
  BOOK_BY_CATEGORY = "/books",
  BOOK_BY_OPTION = "/books-option",
  BOOK_BY_TYPE = "/books-by-type",
  USER_PROFILE = "user-profile",
  USER_ACCOUNT = "user-account",
  USER_LIBRARY = "user-library",
  USER_RULES = "user-rules",
  USER_POLICIES = "user-support",
  USER_SUPPORT = "user-support-24",
  USER_TRANSACTION = "user-transaction",
  USER_WALLET = "user-wallet",
  USER_AFFILIATE = "user-affiliate",
  REFERRER = "referrer",
  BOOK_DETAIL = "book",
  BOOK_DETAIL_ID = "book/:id",
  UPGRADE = "/upgrade",
  READING_ID = "/reading/:id",
  READING = "/reading",
  EBOOK_READING_ID = "/ebook-reading/:id",
  EBOOK_READING = "/ebook-reading",
  PRODUCT_WARRANTY_POLICY = "/product-warranty-policy",
  INFORMATION_SECURITY_POLICY = "/information-security-policy",
  GOODS_INSPECTION_POLICY = "/goods-inspection-policy",
  PAYMENT_POLICY = "/payment-policy",
  SHIPPING_DELIVERY_POLICY = "/shipping-delivery-policy",
  COMPLAINT_HANDLING_POLICY = "/complaint-handling-policy",
  AUTHOR = "/author",
  AUTHOR_DETAIL = "/author/:id",
  BOOK_CATEGORY_FAVORITE = "/book-category-favorites",
  VAS_OPTION_LIST = "/user-profile/user-wallet/vas-options",
  VAS_OPTION_QR = "/user-profile/user-wallet/vas-options/:productId",
}

export const MobileOS = {
  ANDROID: "Android",
  IOS: "iOS",
} as const;

export const AppLink = {
  ANDROID: "https://bit.ly/bookasapp",
  IOS: "https://apps.apple.com/vn/app/bookas/id6478921196",
} as const;

export const LIST_BANK = [
  "VPBank",
  "BIDV",
  "Vietcombank",
  "VietinBank",
  "MBBANK",
  "ACB",
  "SHB",
  "Techcombank",
  "Agribank",
  "HDBank",
  "LienVietPostBank",
  "VIB",
  "SeABank",
  "VBSP",
  "TPBank",
  "OCB",
  "MSB",
  "Sacombank",
  "Eximbank",
  "SCB",
  "VDB",
  "Nam A Bank",
  "ABBANK",
  "PVcomBank",
  "Bac A Bank",
  "UOB",
  "Woori",
  "HSBC",
  "SCBVL",
  "PBVN",
  "SHBVN",
  "NCB",
  "VietABank",
  "BVBank",
  "Vikki Bank",
  "Vietbank",
  "ANZVL",
  "MBV",
  "CIMB",
  "Kienlongbank",
  "IVB",
  "BAOVIET Bank",
  "SAIGONBANK",
  "Co-opBank",
  "GPBank",
  "VRB",
  "VCBNeo",
  "HLBVN",
  "PGBank"
];
